import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, X, MessageCircle, Calendar } from "lucide-react";
import { Button } from "./ui/button";

const CONTACT_EMAIL = "contact@pierre-sainthubert-consulting.com";

export function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleEmailClick = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=Question depuis Épanoui`;
  };

  const handleConsultationClick = () => {
    setIsOpen(false);
    navigate("/consultation/checkout");
  };

  return (
    <>
      {/* Bouton flottant */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed bottom-20 right-6 z-50 w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          isOpen 
            ? 'bg-[#2F4F4F] rotate-90' 
            : 'bg-gradient-to-br from-[#E2725B] to-[#D4A574] hover:scale-110'
        }`}
        data-testid="floating-contact-btn"
        aria-label="Contact"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </button>

      {/* Panel de contact */}
      {isOpen && (
        <div 
          className="fixed bottom-36 right-6 z-50 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-4 duration-300"
          data-testid="contact-panel"
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-[#2F4F4F] to-[#3B7A8C] p-5 text-white">
            <h3 className="font-heading text-lg font-semibold">Une question ?</h3>
            <p className="text-white/80 text-sm mt-1">
              Je suis là pour vous accompagner
            </p>
          </div>

          {/* Content */}
          <div className="p-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#E2725B]/10 to-[#D4A574]/10 flex items-center justify-center">
                <span className="text-2xl">👋</span>
              </div>
              <div>
                <p className="font-medium text-[#2D2D2D]">Pierre Saint-Hubert</p>
                <p className="text-sm text-[#8A8A8A]">Coach & Consultant</p>
              </div>
            </div>

            <p className="text-sm text-[#5C5C5C] mb-5 leading-relaxed">
              Besoin d'un accompagnement personnalisé ? Réservez une consultation ou envoyez-moi un message.
            </p>

            {/* Bouton Consultation - 75€ */}
            <Button
              onClick={handleConsultationClick}
              className="w-full rounded-full bg-gradient-to-r from-[#2F4F4F] to-[#3B7A8C] hover:opacity-90 text-white py-5 mb-3"
              data-testid="book-consultation-btn"
            >
              <Calendar className="w-5 h-5 mr-2" />
              Consultation 30min • 75€
            </Button>

            {/* Bouton Email */}
            <Button
              onClick={handleEmailClick}
              variant="outline"
              className="w-full rounded-full border-2 border-[#E2725B] text-[#E2725B] hover:bg-[#E2725B]/10 py-5"
              data-testid="send-email-btn"
            >
              <Mail className="w-5 h-5 mr-2" />
              M'envoyer un email
            </Button>

            <p className="text-center text-xs text-[#8A8A8A] mt-4">
              {CONTACT_EMAIL}
            </p>
          </div>
        </div>
      )}

      {/* Overlay pour fermer */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/10"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
